import { Paper, Typography, TextField, Grid, IconButton, Button, Select, Checkbox, MenuItem, Autocomplete } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import characteristics from '../data/characteristics.json'

const SkillsEdit = ({ editedItem, index, appFiles, setAppFiles }) => {

    const handleEdit = (newItem) => {
        let newFiles = { ...appFiles };
        let newCat = JSON.parse(appFiles["skills"]);
        newCat[index] = newItem;
        newFiles["skills"] = JSON.stringify(newCat);
        setAppFiles(newFiles);
        localStorage.setItem('appFiles', JSON.stringify(newFiles));
    };

    return (
        <Paper>
            <Typography>Name:</Typography>
            <TextField
                value={editedItem?.skill || ""}
                onChange={(event) =>
                    handleEdit({ ...editedItem, skill: event.target.value })
                }
            />
            <Autocomplete
                sx={{
                    marginTop: "10px",
                    width: "50%",
                }}
                renderInput={(params) => <TextField {...params} label="Characteristic" />}
                value={editedItem?.characteristic ?? null}
                options={characteristics.map((item) => (item.Name))}
                onChange={(event, newValue) =>
                    handleEdit({ ...editedItem, characteristic: newValue })
                }
            />
            <Autocomplete
                sx={{
                    marginTop: "10px",
                    width: "50%",
                }}
                renderInput={(params) => <TextField {...params} label="Type" />}
                value={editedItem?.type ?? null}
                options={["General", "Combat", "Knowledge"]}
                onChange={(event, newValue) =>
                    handleEdit({ ...editedItem, type: newValue })
                }
            />
        </Paper>
    )
}

export default SkillsEdit